import { motion } from "framer-motion";
import { MousePointerClick, Gamepad2, CreditCard, PackageCheck } from "lucide-react";

const STEPS = [
  { icon: MousePointerClick, title: "Pack wählen", body: "Such dir dein OG Pack aus dem Tresor aus." },
  { icon: Gamepad2, title: "Epic-Name angeben", body: "Trage deinen Epic Games Username für die Lieferung ein." },
  { icon: CreditCard, title: "Sicher bezahlen", body: "Bezahle bequem mit PayPal oder Klarna." },
  { icon: PackageCheck, title: "Lieferung erhalten", body: "Wir verifizieren und liefern deinen Account – sofort." },
];

export const HowItWorks = () => {
  return (
    <section id="how" data-testid="how" className="relative py-24 md:py-32 border-t border-white/10 bg-[#0f0f11]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e2ff00] mb-4">So funktioniert's</div>
          <h2 className="font-display font-extrabold text-4xl md:text-5xl tracking-tight">In vier Schritten zum OG</h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.title}
              data-testid={`step-${i + 1}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="relative border border-white/10 bg-[#050505] p-8 hover:border-[#e2ff00]/40 transition-colors"
            >
              <div className="font-mono text-xs text-[#54545c] mb-8">0{i + 1}</div>
              <s.icon size={28} className="text-[#e2ff00] mb-5" />
              <h3 className="font-display font-bold text-lg mb-2">{s.title}</h3>
              <p className="text-sm text-[#8b8b93] leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
